export enum Plans {
  TeamSnapForBusiness = 60,
  TeamSnapForBusinessWithWebsiteToolkit = 61,
  TeamSnapForBusinessWithCompetitionManagement = 62,
  TeamSnapForBusinessWithCompetitionManagementAndWebsiteToolkit = 63,
  FreeTrial21Day = 17,
}

export enum PlansDisplayNames {
  TeamSnapForBusiness = 'TeamSnap for Business',
  TeamSnapForBusinessWithWebsiteToolkit = 'TeamSnap for Business with Website Toolkit',
  TeamSnapForBusinessWithCompetitionManagement = 'TeamSnap for Business with Competition Management',
  TeamSnapForBusinessWithCompetitionManagementAndWebsiteToolkit = 'TeamSnap for Business with Competition Management and Website Toolkit',
  FreeTrial21Day = 'Free Trial 21 Day',
}

export const getPlanDisplayName = (plan: Plans): string => {
  const key = Object.keys(Plans).find(
    (k) => Plans[k as keyof typeof Plans] === +plan
  ) as keyof typeof PlansDisplayNames;
  return PlansDisplayNames[key];
};
